/**
 * Microsoft OAuth callback helpers.
 * Authorize URL and state are issued by promang-api — not built in the browser.
 */

export const MICROSOFT_OAUTH_INTENT_KEY = "promang_ms_oauth_intent";

/** When linking a shared company mailbox, API state carries mailbox id; we keep id for UX only. */
export const MICROSOFT_OAUTH_MAILBOX_ID_KEY = "promang_ms_oauth_company_ai_mailbox_id";

/** Path inside the SPA to open after OAuth completes (set before redirect to Microsoft). */
export const MICROSOFT_OAUTH_RETURN_PATH_KEY = "promang_ms_oauth_return";
